module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/th/1-440dc854994ff0ff9ecf7c5869b9f8b8.jpg";